import {
  MessageBox,
} from "element-ui";
import systemInfo from './systemInfo'
function getURLParameters(url) {
  const url_ = decodeURIComponent(url || location.href)
  const obj = (url_.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
    (a, v) => {
      a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)
      return a
    },
    {}
  )
  Object.keys(obj).forEach(key => {
    obj[key] = decodeURIComponent(obj[key])
  })
  return obj
}
function getAuthInfo() {
  const params = getURLParameters()
  return {
    token: params.token || localStorage['token'],
    refresh_token: params.refresh_token || localStorage['refresh_token']
  }
}
function setRefreshTokenStorage(refreshToken) {
  sessionStorage['refresh_token'] = refreshToken
}
function removeRefreshTokenStorage() {
  sessionStorage.removeItem['refresh_token']
}
function removeTokenStorage() {
  sessionStorage.removeItem['token']
}
function setTokenStorage(token) {
  sessionStorage['token'] = token
}
function removeTokenStorage() {
  sessionStorage.removeItem['token']
}
function removeUserInfo() {
  sessionStorage.removeItem('user_info')
}
function getUserInfo(issignStr) {
  const data = sessionStorage['user_info']
  if (data) {
    return !issignStr ? JSON.parse(data) : data
  } else {
    return !issignStr ? {} : '{}'
  }
}
function setUserInfo(obj) {
  sessionStorage['user_info'] = JSON.stringify(obj)
}
function removeTokenRefreshToken() {
  removeRefreshTokenStorage()
  removeTokenStorage()
}
function setTokenRefreshToken(token, refresh_token) {
  setRefreshTokenStorage(refresh_token)
  setTokenStorage(token)
}
function getCommonInfo() {
  const token = systemInfo.getToken()
  var data = {
    isWebframe:1
    // token,
    // lang: localStorage['lang'],
    // user_info: getUserInfo(true),
    // tenant: sessionStorage['tenant'],
  }
  return data
}
function console_css(...arg) {
  let str = ''
  let styles = []
  arg.forEach(item => {
    if (Object.keys(item).length > 0) {
      str += '%c' + item.str
      if (!item.style) {
        item.style = ''
      }
      styles.push(item.style)
    }
  })
  console.log(str, ...styles)
}
function getAllIframe() {
  return Array.from(document.getElementsByTagName("iframe"));
}
function getRecordLogKey() {
  const nowTime = new Date() // 获取年月日
  return `isopenLog-${nowTime.getFullYear()}-${nowTime.getMonth() +
    1}-${nowTime.getDate()}`
}
function getIsRecordLog() {
  return sessionStorage[getRecordLogKey()]
}
function setEvn(data) {
  sessionStorage['evn'] = data
}
function getEvn() {
  const evn = sessionStorage['evn']
  return evn ? JSON.parse(evn) : {}
}
function setExtensionParams(str) {
  sessionStorage["extensionParams"] = str;
}
function getExtensionParams() {
  return sessionStorage["extensionParams"]
    ? JSON.parse(sessionStorage["extensionParams"])
    : {};
}
function removeExtensionParams() {
  sessionStorage.removeItem('extensionParams')
}
// 把&链接的字符串转化成对象形式"a=1&b=2&c=3" 或者 "#a=1&b=2&c=3" 或者 "?a=1&b=2&c=3"或者"/a=1&b=2&c=3"
function transferUrlQueryStrToObj(str) {
  if (!str)return {}
  let _str = str;
  if (str.startsWith("#") || str.startsWith("?") || str.startsWith("/")) {
    _str = str.slice(1);
  } else if (
    str.startsWith("#&") ||
    str.startsWith("?&") ||
    str.startsWith("/&")
  ) {
    _str = str.slice(2);
  }
  return _str.split("&").reduce((totle, pre) => {
    const [prop, value] = pre.split("=");
    totle[prop] = value;
    return totle;
  }, {});
}
function oidcLogin(extraParam = {}) {
  window.mgr.signIn(extraParam)
}

function oidcLoginOut(extraParam = {}) {
  window.mgr.signOut(extraParam)
}
async function hsConfirm(title) {
  return MessageBox.confirm(title, "提示", {
    confirmButtonText: "确定",
    showCancelButton: false,
    closeOnClickModal: false,
    closeOnPressEscape: false,
    showClose: false,
    type: "warning",
    center: true
  });
}

/**
 * 通知所有窗口设置token
 */
function postTokenToAllIframe() {
  const list = getAllIframe()
  list.forEach(item => {
    messagePost.postMessage(
      {
        type: 'setToken',
        data: systemInfo.getToken()
      },
      item.contentWindow
    )
  })
}
function findTargetMenuItem(item_key) {
  const data =systemInfo.getMenuSourceData()
  return data.find(item => item.item_key === item_key);
}
export default {
  getURLParameters,
  getAuthInfo,
  removeUserInfo,
  getUserInfo,
  setUserInfo,
  setRefreshTokenStorage,
  removeRefreshTokenStorage,
  removeTokenStorage,
  setTokenStorage,
  removeTokenRefreshToken,
  setTokenRefreshToken,
  getCommonInfo,
  console_css,
  getAllIframe,
  getIsRecordLog,
  getRecordLogKey,
  setEvn,
  getEvn,
  setExtensionParams,
  getExtensionParams,
  removeExtensionParams,
  transferUrlQueryStrToObj,
  oidcLogin,
  oidcLoginOut,
  hsConfirm,
  postTokenToAllIframe,
  findTargetMenuItem
}



// WEBPACK FOOTER //
// ./src/utils/toolFunction.js